import { createSlice } from "@reduxjs/toolkit";

export const ratingSlice = createSlice({
  name: "rating",
  initialState: {
    ratings: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    getRatingStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getRatingSuccess: (state, action) => {
      state.isFetching = false;
      state.ratings = action.payload;
    },
    getRatingFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    // UPDATE
    updateAppointmentStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    updateAppointmentSuccess: (state, action) => {
      console.log(action.payload, 'payload in service')
      state.isFetching = false;
      state.ratings[
        state.ratings.findIndex((item) => item._id === action.payload.id)
      ] = action.payload.category;
    },
    updateAppointmentFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});

export const {
  getRatingStart,
  getRatingSuccess,
  getRatingFailure,
} = ratingSlice.actions;

export default ratingSlice.reducer;
